import React from 'react'
import { Card } from 'react-bootstrap';
import ProjectLinks from './ProjectLinks'
import './ProjectCard.css';
import ProjectFavorite from './ProjectFavorite';
/**
 * props:
name
year
category
challenge
excerpt
link
links
*/
function getPrize(prize) {
    if (prize === "N") {
        return <span className="global-nominee">Global Nominee</span>
    } else if (prize === "F") {
        return <span className="finalist">Finalist</span>
    } else if (prize === "W") {
        return <span className="winner">Winner</span>
    } else {
        return "";
    }
}

const ProjectCard = (props) => {
    return (
        <Card key={props.index} className="bg-white rounded project" >
            <Card.Body>
                <Card.Title className="project-title"><b>{props.name} ({props.year})</b>
                    <ProjectFavorite {...props} />
                </Card.Title>
                {props.prize &&
                    <div className="project-award">
                        {getPrize(props.prize)}
                    </div>}
                <div key='a'><span className="badge badge-secondary">category</span> {props.category}
                    {props.category !== props.challenge && ` | ${props.challenge}`}
                </div>
                <p><span className="badge badge-dark">excerpt</span> {props.excerpt}</p>
                <ProjectLinks {...props} />
            </Card.Body>
        </Card>
    )
}

export default ProjectCard